import React from 'react';
import Icon from './Icon';

export default function SearchIcon(props) {
  return (
    <Icon viewBox="0 0 18 18" {...props}>
      <g transform="translate(2, 2.25) scale(0.8)">
        <path d="M17 17L13.1394 13.1394M13.1394 13.1394C14.4263 11.8526 15.2222 10.0748 15.2222 8.11111C15.2222 4.18375 12.0385 1 8.11111 1C4.18375 1 1 4.18375 1 8.11111C1 12.0385 4.18375 15.2222 8.11111 15.2222C10.0748 15.2222 11.8526 14.4263 13.1394 13.1394Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </g>
    </Icon>
  );
}
